import {
  Container,
  Hero,
  HeroSection,
  CTAButton,
  CategoriesSection,
  CategoryCard,
  FeaturesSection,
  FeatureCard,
  FeaturedCalculatorsSection,
  CalculatorCard,
  StatsSection,
  StatCard,
  HowItWorksSection,
  Step,
  QuickLinksSection,
  QuickLink,
} from './styles'
import hero from '../../assets/hero.svg'

export function Home() {
  const categories = [
    {
      title: 'Concreto',
      description: 'Calculadoras para dimensionamento e verificação de elementos estruturais em concreto armado',
      path: '/concreto',
      icon: '🏗️',
    },
    {
      title: 'Aço',
      description: 'Dimensionamento de elementos estruturais em aço laminado e formado a frio',
      path: '/aco',
      icon: '⚙️',
    },
    {
      title: 'Alvenaria',
      description: 'Verificação de elementos de alvenaria estrutural',
      path: '/alvenaria',
      icon: '🧱',
    },
    {
      title: 'Elétrica',
      description: 'Dimensionamento de circuitos e eletrodutos',
      path: '/eletrica',
      icon: '⚡',
    },
    {
      title: 'Hidrossanitário',
      description: 'Cálculos para sistemas hidrossanitários e pluviais',
      path: '/hidrossanitario',
      icon: '💧',
    },
    {
      title: 'Geotecnia',
      description: 'Dimensionamento de fundações e estacas',
      path: '/geotecnia/',
      icon: '🏔️',
    },
  ]

  const features = [
    {
      icon: '✅',
      title: 'Validação em Tempo Real',
      description: 'Validação instantânea de todos os campos com feedback visual',
    },
    {
      icon: '📊',
      title: 'Histórico de Cálculos',
      description: 'Navegue entre seus cálculos anteriores facilmente',
    },
    {
      icon: '📋',
      title: 'Exportação para Word',
      description: 'Copie os resultados formatados diretamente para o Word',
    },
    {
      icon: '💾',
      title: 'Salvar/Carregar',
      description: 'Salve seus cálculos e carregue quando precisar',
    },
    {
      icon: '📱',
      title: 'Design Responsivo',
      description: 'Funciona perfeitamente em desktop, tablet e celular',
    },
    {
      icon: '🚀',
      title: 'Resultados Instantâneos',
      description: 'Cálculos rápidos e precisos com interface intuitiva',
    },
  ]

  const featuredCalculators = [
    {
      title: 'Flexão em Concreto',
      description: 'Dimensionamento de vigas e lajes à flexão',
      path: '/concreto/flexao',
      category: 'Concreto',
    },
    {
      title: 'Cisalhamento',
      description: 'Verificação e dimensionamento ao cisalhamento',
      path: '/concreto/cisalhamento',
      category: 'Concreto',
    },
    {
      title: 'Circuitos Elétricos',
      description: 'Dimensionamento de condutores e proteções',
      path: '/eletrica/circuitos',
      category: 'Elétrica',
    },
  ]

  const steps = [
    {
      number: '1',
      title: 'Escolha a Calculadora',
      description: 'Selecione a área de engenharia e o tipo de cálculo desejado',
    },
    {
      number: '2',
      title: 'Insira os Dados',
      description: 'Preencha os campos com validação em tempo real',
    },
    {
      number: '3',
      title: 'Obtenha os Resultados',
      description: 'Visualize e exporte os cálculos detalhados',
    },
  ]

  const totalCalculators = 21 // Pode ser calculado dinamicamente
  const totalCategories = 6

  return (
    <Container>
      <HeroSection>
        <div className="hero-content">
          <Hero src={hero} alt="Engenharia ilustração" className="hero-image-left" />
          <section>
            <h1>👏 Simplifique seus Cálculos de Engenharia</h1>
            <p className="subtitle">Plataforma completa de calculadoras para engenheiros</p>
            <p>
              Nosso site oferece um conjunto completo de calculadoras para engenheiros, projetadas para facilitar seus
              cálculos estruturais, hidrossanitários e elétricos. Tudo em um só lugar, com precisão e praticidade.
            </p>
            <CTAButton to="/concreto">Começar Agora</CTAButton>
          </section>
          <Hero src={hero} alt="Engenharia ilustração" className="hero-image-right" />
        </div>
      </HeroSection>

      <StatsSection>
        <StatCard>
          <h3>{totalCalculators}+</h3>
          <p>Calculadoras Disponíveis</p>
        </StatCard>
        <StatCard>
          <h3>{totalCategories}</h3>
          <p>Áreas de Engenharia</p>
        </StatCard>
        <StatCard>
          <h3>Gratuito</h3>
          <p>Para Começar</p>
        </StatCard>
      </StatsSection>

      <CategoriesSection>
        <h2>Áreas de Engenharia</h2>
        <p className="section-description">Escolha a área para acessar as calculadoras especializadas</p>
        <div className="categories-grid">
          {categories.map((category, index) => (
            <CategoryCard key={index} to={category.path}>
              <span className="category-icon">{category.icon}</span>
              <h3>{category.title}</h3>
              <p>{category.description}</p>
            </CategoryCard>
          ))}
        </div>
      </CategoriesSection>

      <FeaturesSection>
        <h2>Por que usar nossas Calculadoras?</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <FeatureCard key={index}>
              <span className="feature-icon">{feature.icon}</span>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </FeatureCard>
          ))}
        </div>
      </FeaturesSection>

      <FeaturedCalculatorsSection>
        <h2>Calculadoras em Destaque</h2>
        <p className="section-description">As ferramentas mais utilizadas por nossos usuários</p>
        <div className="calculators-grid">
          {featuredCalculators.map((calc, index) => (
            <CalculatorCard key={index} to={calc.path}>
              <span className="category-badge">{calc.category}</span>
              <h3>{calc.title}</h3>
              <p>{calc.description}</p>
              <span className="arrow">→</span>
            </CalculatorCard>
          ))}
        </div>
      </FeaturedCalculatorsSection>

      <HowItWorksSection>
        <h2>Como Funciona</h2>
        <p className="section-description">Simples e intuitivo em apenas 3 passos</p>
        <div className="steps-container">
          {steps.map((step, index) => (
            <Step key={index}>
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </Step>
          ))}
        </div>
      </HowItWorksSection>

      <QuickLinksSection>
        <h2>Acesso Rápido</h2>
        <div className="quick-links-grid">
          <QuickLink to="/concreto/flexao">Flexão em Concreto</QuickLink>
          <QuickLink to="/concreto/cisalhamento">Cisalhamento</QuickLink>
          <QuickLink to="/concreto/torcao">Torção</QuickLink>
          <QuickLink to="/eletrica/circuitos">Circuitos Elétricos</QuickLink>
          <QuickLink to="/hidrossanitario/fossa">Fossa Séptica</QuickLink>
          <QuickLink to="/aco/laminado-flexao">Flexão em Aço</QuickLink>
        </div>
      </QuickLinksSection>
    </Container>
  )
}
